import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { productCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCard";
import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

Object.assign(productCardStyles, {
    ...productCardStyles,
    gridContainer: {
        gap: 0,
        css: css`
            padding: 30px 0;
            min-width: 320px; /* prevent overlap with second column */
            border: 1px solid ${CarotekColors.grey12};
            border-top: 0;
            padding: 1.5rem 0.9375rem;
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 2, 2],
        css: css`
            padding-right: 20px;
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 10, 10],
    },
    searchScoreDataGridItem: {
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
});
